import { Component, EventEmitter, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IToolPanel, IToolPanelParams } from 'ag-grid-community';
import { GlobalsService } from '../../services/globals.service';
import { PageMetaService } from '../../services/page-meta.service';
import { StorageService } from '../../services/storage.service';
import { ViasConnectionService } from '../../services/vias-connection.service';
import { ButtonBarItem } from '../buttonbar/buttonbar.component';

@Component({
  selector: 'vias-actions-sidebar',
  template: `
<div class="actionSidebar">
    <vias-buttonbar
        [class]="buttonBarClass"
        [numLocale]="numLocale"
        [buttons]="buttonBarItems"
        (itemClick)="butonclickHandler($event)"
    ></vias-buttonbar>
</div>`
})
export class ActionsSideToolBarComponent implements IToolPanel {
  private params: IToolPanelParams;

  numLocale: string;
  buttonBarClass: string = 'sideButtonBarContainer';
  buttonBarItems: ButtonBarItem[] = [];

//   @Output() itemClick: EventEmitter<ButtonBarItem> = new EventEmitter<ButtonBarItem>();
  constructor(
    protected next: ActivatedRoute,
    protected route: Router,
    protected storage: StorageService,
    protected globals: GlobalsService,
    protected viasService: ViasConnectionService,
    protected dialog: MatDialog,
    protected translate: TranslateService
  ) {}
  agInit(params: IToolPanelParams): void {
    this.params = params;

    // calculate stats when new rows loaded, i.e. onModelUpdated
    this.params.api.addEventListener(
      'modelUpdated',
      this.updateTotals.bind(this)
    );
  }
  butonclickHandler(event: ButtonBarItem): void {
    console.log(this.params);
    if (event.onClick) {
      event.onClick(event, this.route, this.params.api.getSelectedRows(),
        this.translate, this.storage, this.globals, this.viasService, this.dialog);
    //   this.itemClick.emit(event);
    }
  }
  refresh(): void { }

  updateTotals(): void {
    const sidebar: any = this.params.api.getSideBar();
    // 3. buton
    if (sidebar.toolPanels[2] !== undefined) {
      if (sidebar.toolPanels[2].sideMenuItems !== undefined) {
        this.buttonBarItems = sidebar.toolPanels[2].sideMenuItems;
      }
    }
    // if (this.params.api.gridOptionsWrapper.gridOptions.sideMenuItems !== undefined){
    //     this.buttonBarItems = this.params.api.gridOptionsWrapper.gridOptions.sideMenuItems as ButtonBarItem[];
    // }

    // }
    // var numGold = 0,
    //   numSilver = 0,
    //   numBronze = 0;

    // this.params.api.forEachNode(function (rowNode) {
    //   let data = rowNode.data;
    //   console.log('aaaaa', rowNode);
    // //   if (data.gold) numGold += data.gold;
    // //   if (data.silver) numSilver += data.silver;
    // //   if (data.bronze) numBronze += data.bronze;
    // });

    // this.numMedals = numGold + numSilver + numBronze;
    // this.numGold = numGold;
    // this.numSilver = numSilver;
    // this.numBronze = numBronze;
  }
}
